// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__31h4l","savePackageButton":"ClientWallet_savePackageButton__2FTiY"};